import { AnimatePresence } from "motion/react";
import { FC } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { AccessControl } from "@ryde/controls";
import { usePageContext } from "@ryde/redux";

import {
  AddNewFormGeneric,
  EditFormGeneric,
  SystemParamsEdit,
} from "../layout-edit";
import { AnimatedPage } from "../route-animations";

export const LayoutCrudRoutes: FC = () => {
  const { entity } = usePageContext();
  const location = useLocation();

  const isSystemParams = entity === "systemParam";
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="new"
          element={
            <AccessControl entity={entity} action="create">
              <AnimatedPage>
                <AddNewFormGeneric entity={entity} />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="add"
          element={
            <AccessControl entity={entity} action="create">
              <AnimatedPage>
                {isSystemParams ? (
                  <SystemParamsEdit isAddRoute />
                ) : (
                  <EditFormGeneric entity={entity} isAddRoute />
                )}
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="add/:id"
          element={
            <AccessControl entity={entity} action="update">
              <AnimatedPage>
                {isSystemParams ? (
                  <SystemParamsEdit isAddRoute />
                ) : (
                  <EditFormGeneric entity={entity} isAddRoute />
                )}
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="edit/:id"
          element={
            <AccessControl entity={entity} action="read">
              <AnimatedPage>
                {isSystemParams ? (
                  <SystemParamsEdit />
                ) : (
                  <EditFormGeneric entity={entity} />
                )}
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
      </Routes>
    </AnimatePresence>
  );
};
